const pad2 = (n: number): string => String(n).padStart(2, '0');

export function formatPace(secondsPerKm: number): string {
  const s = Math.round(secondsPerKm);
  return `${Math.floor(s / 60)}:${pad2(s % 60)}`;
}

export function parsePace(text: string): number | null {
  const match = /^(\d{1,2}):([0-5]\d)$/.exec(text.trim());
  return match === null ? null : Number(match[1]) * 60 + Number(match[2]);
}

export const paceOf = (speedMs: number): number => 1000 / speedMs;
